$(function() {
	
	$("#copy-qr-url").on("click", function(e) {
		ebusy.copyToClipboard($("#qr-url"));
	});
	
	$(document).on("click", ".qr-code-generator", function(e) {
		var url = $(e.target).closest("[data-qr-url]").data("qr-url");
		
		$("#qr-content").empty();
		$("#qr-content").qrcode({render: 'image', text: url});
		$("#qr-url").val(url);
		$("#qr-modal").modal("show");
	});
});